module.exports = __webpack_public_path__ + "img/bank.ae21903d.png";